<!--资源服务器的文件上传-->
<template>
    <div class="images-list" @mouseenter="openUploadShowClick" @mouseleave="openUploadShow = false">
        <span v-show="openUploadShow" class="openUpload" @click="open">
            <i class="el-icon-upload2"></i>
            继续上传
        </span>
        <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :on-change="fileListChange"
                   :before-upload="handleBeforeUpload" :on-success="handleSuccess" :on-error="handleUploadError"
                   :on-remove="handleRemove" :on-exceed="handleExceed" :on-preview="handlePictureCardPreview" :file-list="fileList"
                   :multiple="fileLimit > 1" :data="paramsData" :limit="fileLimit" :auto-upload="false" :list-type="listType">
            <i v-if="listType === 'picture-card'" class="el-icon-plus"></i>
            <!-- <div v-if="showTip" slot="tip" class="el-upload__tip">只能上传{{fileTypeName || 'jpg/png'}}文件，且不超过 {{fileSize}}MB</div> -->
        </el-upload>

        <el-dialog v-if="this.showFlodNames.length > 0" class="productTypeDialog" custom-class="chatGPTDialog" :append-to-body="true" title=""
                   :visible.sync="picShow" width="60%">
            <div id="middle">
                <span v-if="showFlodNamesFileList.filter(it => it.flodName === pointIndex).length > 0 && (!showFlodNamesFileList.filter(it => it.flodName === pointIndex)[checkedPic] || !showFlodNamesFileList.filter(it => it.flodName === pointIndex)[checkedPic].id) && parentId > 0"
                      @click="singleUploadFlodName(showFlodNamesFileList.filter(it => it.flodName === pointIndex)[checkedPic])" class="tips noways"><i :class="icon"></i>{{
                                iconText
                    }}</span>
                <i v-show="isExistence" class="el-icon-arrow-left pointLeft" @click="reduceFlodName"></i>
                <i v-show="isExistence" class="el-icon-arrow-right pointRight" @click="addFlodName"></i>
                <img :src="bigPic"></img>
                <span v-if="isExistence" class="Page">{{ checkedPic + 1 }}/{{ showFlodNamesFileList.filter(it => it.flodName === pointIndex).length }}</span>
            </div>
            <div class="btnBox">
                <el-button @click="pointActive(n)" :class="pointIndex === n ? 'active' : ''" v-for="(n, index) in showFlodNames" :key="index" round>
                    {{ n }}（{{ showFlodNamesFileList.filter(it => it.flodName === n).length }}）
                </el-button>
            </div>
            <div id="photoWall" class="hiddenScrollbar" v-if="isExistence">
                <div class="picKuai" :class="checkedPic === index ? 'checkedPic' : ''"
                     v-for="(pic, index) in showFlodNamesFileList.filter(it => it.flodName === pointIndex) || []" :key="index">
                    <img :src="pic.url" @click="checkedPicPointFlodName(pic, index)"></img>
                    <span @click="deletePicFlodName(index)" class="tips delete"><i class="el-icon-delete"></i></span>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-else class="productTypeDialog" custom-class="chatGPTDialog" :append-to-body="true" title=""
                   :visible.sync="picShow" width="60%">
            <div id="middle">
                <span v-if="fileList.length > 0 && (!fileList[checkedPic] || !fileList[checkedPic].id) && parentId > 0"
                      @click="singleUpload(fileList[checkedPic])" class="tips noways"><i :class="icon"></i>{{
                                iconText
                    }}</span>
                <i v-show="isExistence" class="el-icon-arrow-left pointLeft" @click="reduce"></i>
                <i v-show="isExistence" class="el-icon-arrow-right pointRight" @click="add"></i>
                <img :src="bigPic"></img>
                <span v-if="isExistence" class="Page">{{ checkedPic + 1 }}/{{ fileList.length }}</span>
            </div>
            <div id="photoWall" class="hiddenScrollbar" v-if="isExistence">
                <div class="picKuai" :class="checkedPic === index ? 'checkedPic' : ''"
                     v-for="(pic, index) in fileList || []" :key="index">
                    <img :src="pic.url" @click="checkedPicPoint(pic, index)"></img>
                    <span @click="deletePic(index)" class="tips delete"><i class="el-icon-delete"></i></span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {UploadMinxin} from "@/components/Upload/UploadMinxin";
import {ShowFlodNamesMinxins} from "@/components/Upload/ShowFlodNamesMinxins";
import {pictureMinxin1} from "@/components/minxins/picture1";

export default {
        name: 'ResourceUpload',
        mixins: [UploadMinxin, pictureMinxin1, ShowFlodNamesMinxins],
        data() {
                return {
                        icon: 'el-icon-upload2',
                        iconText: '点击上传',
                        uploadUrl: "",
                        picShow: false,
                        openUploadShow: false,
                        pointIndex: this.showFlodNames[0]
                }
        },
        methods: {
                pointActive(n) {
                        this.pointIndex = n
                        var filter = this.showFlodNamesFileList.filter(u => u.flodName === n);
                        if (typeof filter[0] !== 'undefined') {
                                this.bigPic = filter[0].url
                        }
                        this.checkedPic = 0
                },
                openUploadShowClick() {
                        if (this.$refs['upload'].uploadFiles.length > 0) {
                                this.openUploadShow = true
                        }
                },
                open() {
                        if (this.isSpread) {
                                this.$emit("otherClick")
                        } else {
                                this.$refs['upload'].$refs['upload-inner'].handleClick()
                        }
                },
                deletePic(index) {
                        if (this.fileList[index].id) {
                                this.deletePicData(this.fileList[index].id).then((res) => {
                                        if (res) {
                                                this.fileList = this.fileList.filter((n) => n.id !== this.fileList[index].id);
                                                this.reduce()
                                                if (this.fileList.length === 0) {
                                                        this.checkedPic = 0
                                                        this.isExistence = false
                                                        this.bigPic = ''
                                                        this.picShow = false
                                                } else {
                                                        this.bigPic = this.fileList[this.checkedPic].url
                                                }
                                        }
                                });
                        } else {
                                this.fileList = this.fileList.filter((n) => n.uid !== this.fileList[index].uid);
                                this.reduce()
                                if (this.fileList.length === 0) {
                                        this.checkedPic = 0
                                        this.isExistence = false
                                        this.bigPic = ''
                                        this.picShow = false
                                } else {
                                        this.bigPic = this.fileList[this.checkedPic].url
                                }
                        }
                },
                // 此方法只有 parentId 存在的情况下生生效
                singleUpload(uploadPic) {
                        this.icon = "el-icon-loading"
                        this.iconText = "上传中..."
                        this.manualUpload([uploadPic], this.parentId).then(res => {
                                if (res) {
                                        this.icon = "el-icon-check"
                                        this.iconText = "上传成功"
                                        setTimeout(() => {
                                                this.icon = 'el-icon-upload2'
                                                this.iconText = '点击上传'
                                                if (document.getElementsByClassName("noways")[0]) {
                                                        document.getElementsByClassName("noways")[0].style.display = 'none'
                                                }
                                        }, 1000)
                                        this.fileList = this.fileList.filter(x => x.url !== uploadPic.url);
                                        this.fileList.splice(this.checkedPic, 0, res)
                                        if (this.fileList.length > 0) {
                                                this.bigPic = this.fileList[0].url
                                        }
                                        this.bigPic = this.fileList[this.checkedPic].url
                                }
                        })
                        console.log('single', uploadPic)
                }
        }
}
</script>

<style lang="scss" scoped>
.active {
  background-color: #53B0A3 !important;
  color: #fff !important;
}

.images-list {
  //border: 1px dashed #d5d5d5;
  //padding: 10px;
  position: relative !important;
  z-index: 999;
  color: #fff;
  border-radius: 4px;
  background: #fff;
  width: fit-content;

  /deep/ .el-upload {
  }
}

.tips {
  position: absolute;
  top: 20px;
  width: 70px;
  color: white;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);

  > i {
    padding-top: 2px;
  }

  &:hover {
    cursor: pointer;
  }
}

.delete {
  right: 3px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  top: 2px;
}

.images-list {
  /deep/ .openUpload {
    position: absolute;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #5677fc;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 2;

    &:hover {
      cursor: pointer;
    }

    > i {
      font-weight: 700;
    }
  }

  /deep/ .el-upload-list__item-actions {
    position: absolute;
    z-index: 100;
  }

  /deep/ .el-upload-list--picture-card {
    .el-upload-list__item {
      position: absolute;
      z-index: 99;
    }
  }
}

.productTypeDialog /deep/ .el-dialog {
  background: rgba(0, 0, 0, 0.8);
}

.productTypeDialog {
  top: -100px !important;
}

#middle {
  position: relative;
  width: 100%;
  border-radius: 15px;
  margin-top: 10px;
  padding: 20px;

  .Page {
    width: 80px;
    height: 26px;
    border-radius: 13px;
    background: rgba(0, 0, 0, .8);
    position: absolute;
    bottom: 10px;
    left: 50%;
    margin-left: -40px;
    text-align: center;
    line-height: 26px;
    color: #fff;
  }

  > img {
    width: 100%;
    height: 500px;
    border-radius: 15px;
    //大图按图的大小显示
    object-fit: scale-down;
  }

  .pointLeft {
    position: absolute;
    top: 45%;
    display: flex;
    width: 30px;
    height: 30px;
    background: white;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    left: 3px;
    font-size: 16px;
    font-weight: 700;

    &:hover {
      cursor: pointer;
    }
  }

  .pointRight {
    position: absolute;
    top: 45%;
    display: flex;
    width: 30px;
    height: 30px;
    background: white;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    right: 3px;
    font-size: 16px;
    font-weight: 700;

    &:hover {
      cursor: pointer;
    }
  }
}

#bottom {
  .navAlbum {
    overflow: hidden;
    height: 100%;
    margin-left: 0;

    > li {
      float: left;
      height: 36px;
      line-height: 36px;
      padding: 0 16px;
      text-align: center;
      font-size: 14px;
      border: 1px solid #ededed;
      border-radius: 18px;
      color: #5c5c5c;
      margin: 10px 10px 0 0;
      cursor: pointer;
      position: relative;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
    }
  }

  .checked {
    border: 0;
    background: #4db46a;
    color: white !important;
  }
}

.btnBox {
  display: flex;
  padding-top: 10px;
  flex-wrap: wrap;
}

#photoWall {
  padding-top: 10px;
  display: -webkit-inline-box;
  width: 100%;
  overflow-x: auto;

  .picKuai {
    position: relative;
    width: 120px;
    height: 120px;
    overflow-y: clip;
    margin-right: 5px;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .checkedPic {
    border: 2px solid #4db46a;
    box-shadow: 0 0 5px #4db46a;
  }
}</style>